import { t } from 'ttag'

import skillsDecoderSvg from '@h2/assets/svg/blockGraphics/skillsDecoder.svg'
import { Promotion } from '@h2/features/dashboard/promotion'

const ResumeLessonCard = ({ recommendation }) => {
  const { nonTemplateDetails } = recommendation

  return (
    <Promotion color="orange" variant="continue">
      <Promotion.PreHeading>{t`Continue Towards Your Goal`}</Promotion.PreHeading>
      <Promotion.Heading>{nonTemplateDetails?.heading}</Promotion.Heading>
      <Promotion.Text>{nonTemplateDetails?.body}</Promotion.Text>
      <Promotion.Button href={nonTemplateDetails?.url}>
        {nonTemplateDetails?.buttonTitle}
      </Promotion.Button>
      <Promotion.Image src={skillsDecoderSvg} />
    </Promotion>
  )
}

export { ResumeLessonCard }
